module.exports = __webpack_public_path__ + "img/tianjia.a1124cf6.svg";